export default "__VITE_ASSET__52bf4292__"